import { render, staticRenderFns } from "./recycleTask.vue?vue&type=template&id=113d7e14"
import script from "./recycleTask.vue?vue&type=script&lang=js"
export * from "./recycleTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports